import React from 'react';
import { Box, Paper, Typography, Avatar, CircularProgress } from '@material-ui/core';
import EventNoteIcon from '@material-ui/icons/EventNote';
import PeopleIcon from '@material-ui/icons/People';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import AssignmentIcon from '@material-ui/icons/Assignment';

export function KpiCards({ classes, loading, totalSessions, activeUsers, avgDuration, totalActions }) {
	return (
		<Box className={classes.kpiRow}>
			<Paper className={classes.kpiCard} elevation={0}>
				<Avatar className={classes.kpiIcon}><EventNoteIcon /></Avatar>
				<Box className={classes.kpiTextWrap}>
					<Typography className={classes.kpiLabel}>Total Sessions</Typography>
					<Typography className={classes.kpiValue}>{loading ? <CircularProgress size={20} /> : totalSessions}</Typography>
				</Box>
			</Paper>
			<Paper className={classes.kpiCard} elevation={0}>
				<Avatar className={classes.kpiIcon}><PeopleIcon /></Avatar>
				<Box className={classes.kpiTextWrap}>
					<Typography className={classes.kpiLabel}>Active Users</Typography>
					<Typography className={classes.kpiValue}>{loading ? <CircularProgress size={20} /> : activeUsers}</Typography>
				</Box>
			</Paper>
			<Paper className={classes.kpiCard} elevation={0}>
				<Avatar className={classes.kpiIcon}><AccessTimeIcon /></Avatar>
				<Box className={classes.kpiTextWrap}>
					<Typography className={classes.kpiLabel}>Avg. Session Duration</Typography>
					<Typography className={classes.kpiValue}>{loading ? <CircularProgress size={20} /> : `${avgDuration} mins`}</Typography>
				</Box>
			</Paper>
			<Paper className={classes.kpiCard} elevation={0}>
				<Avatar className={classes.kpiIcon}><AssignmentIcon /></Avatar>
				<Box className={classes.kpiTextWrap}>
					<Typography className={classes.kpiLabel}>Total Actions</Typography>
					<Typography className={classes.kpiValue}>{loading ? <CircularProgress size={20} /> : (Number(totalActions) || 0).toLocaleString()}</Typography>
				</Box>
			</Paper>
		</Box>
	);
}
